import {Component, EventEmitter, Input, OnInit} from '@angular/core';
import {ICurrentStatistic, StatisticService} from "../../../services/statistic.service";
import {Organization} from "../../../models/organization";

@Component({
  selector: 'app-current',
  templateUrl: './current.component.html',
  styleUrls: ['./current.component.scss']
})
export class CurrentComponent {
  @Input() organization: Organization;
  data: ICurrentStatistic = null;
  reloadCars: EventEmitter<any> = new EventEmitter<any>();

  constructor(private statisticService: StatisticService) { }

  ngOnChanges() {
    this.getData();
  }

  getData() {
    if (this.organization === undefined) return;
    this.statisticService.getCurrent(this.organization ? this.organization.id : null).subscribe(res => {
      if (res.success) {
        this.data = res.data;
        this.reloadCars.emit(this.data);
      }
    })
  }
}
